// extracted by mini-css-extract-plugin
export default {"wrapper":"AdvantagesSection_wrapper__+u1+v","signInPage":"AdvantagesSection_signInPage__m7Jnp","signUpPage":"AdvantagesSection_signUpPage__U36-E"};